// useLoading.ts
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setLoading } from '../state/loadingSlice';

interface LoadingOptions {
	message?: string;
	isLoading: boolean;
}

export function useLoading({ isLoading, message }: LoadingOptions) {
	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(setLoading({ message, isLoading }));
		return () => {
			// This ensures when the component using this effect is unmounted,
			// any spinners will go away
			dispatch(setLoading({ message: undefined, isLoading: false }));
		};
	}, [message, isLoading, dispatch]);
}
